import { Claim } from "../claim";
import { ItemMenuPai } from "../menu/item-menu-pai";

export class DnSenacSeguranca{
  claims:Claim;
  menus:ItemMenuPai;
  nomeUsuario:string;
  seguranca: string;
  aceitePoliticaPrivacidade: boolean = false;
  aceitePoliticaPrivacidadeSIC: boolean = false;
  loginUsuario: string;

  constructor(values: any = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/localstorage/dn-senac-seguranca.ts